import styled from 'styled-components';

export const FlexColumnsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
